// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big-checkbox[data-v-28eae13a] {\n  width: 30px;\n  height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
